import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-blue-500 via-yellow-300/95 to-secondary overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border-2 border-black rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-black rounded-lg rotate-45"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border-2 border-black rounded-full"></div>
        <div className="absolute bottom-32 right-1/3 w-20 h-20 border border-black rounded-lg rotate-12"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-black">
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
                <Icon name="MessageCircle" size={24} color="white" />
              </div>
              <span className="text-white font-medium">Get In Touch</span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              Connect with US
              <span className="block text-accent"></span>
            </h1>
            
            <p className="text-xl text-black mb-8 leading-relaxed">
              Ready to transform your technical career? Our expert counselors are here to guide you through your educational journey. Get personalized advice, career guidance, and application support.
            </p>
          </div>

          {/* Quick Contact Stats */}
          <div className="lg:pl-8">
            <div className="grid grid-cols-2 gap-6">
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="w-12 h-12 bg-success rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Icon name="Users" size={24} color="white" />
                </div>
                <h3 className="text-2xl font-bold text-yellow-700 mb-2">140+</h3>
                <p className="text-black text-lg">Professional Staff</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="w-12 h-12 bg-warning rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Icon name="Briefcase" size={24} color="white" />
                </div>
                <h3 className="text-2xl font-bold text-black mb-2">70+</h3>
                <p className="text-blue-700 text-lg">Technical Programmes</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Icon name="Award" size={24} color="white" />
                </div>
                <h3 className="text-2xl font-bold text-blue-800 mb-2">10+</h3>
                <p className="text-black text-lg">Years Experience</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;